// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const CloseHeavy = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			clipRule="evenodd"
			d="m10.29 8.5 6.172-6.172a1.266 1.266 0 1 0-1.79-1.79L8.5 6.71 2.327.537a1.266 1.266 0 0 0-1.79 1.79L6.71 8.5.537 14.672a1.266 1.266 0 1 0 1.79 1.79L8.5 10.29l6.172 6.172a1.262 1.262 0 0 0 1.79 0 1.265 1.265 0 0 0 0-1.79L10.29 8.5Z"
		/>
	</svg>
);
export default CloseHeavy;
